var map = {
	"./da.json": 3705,
	"./de.json": 1229,
	"./en.json": 7473,
	"./es.json": 6018,
	"./fr.json": 7946,
	"./it.json": 8355,
	"./nb.json": 3730,
	"./nl.json": 4340,
	"./pt.json": 750,
	"./sv.json": 3539
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 6761;